import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { Link } from 'wouter'

// Botones grandes (≥ 48 px de alto) para dedos y vista de 35–65 años.
export type ButtonVariant = 'primary' | 'secondary' | 'ghost'

const BASE =
	'inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl px-5 py-3 text-base font-semibold transition disabled:cursor-not-allowed disabled:opacity-50'
const VARIANTS: Record<ButtonVariant, string> = {
	primary: 'bg-forest-700 text-white shadow-sm active:bg-forest-800',
	secondary: 'border-2 border-forest-700 bg-white text-forest-800 active:bg-forest-50',
	ghost: 'text-forest-800 underline-offset-4 hover:underline',
}

export const buttonClasses = (variant: ButtonVariant = 'primary', fullWidth = false): string =>
	[BASE, VARIANTS[variant], fullWidth ? 'w-full' : ''].filter(Boolean).join(' ')

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & { variant?: ButtonVariant; fullWidth?: boolean }

export const Button = ({ variant, fullWidth, className = '', type = 'button', ...props }: ButtonProps) => (
	<button type={type} className={`${buttonClasses(variant, fullWidth)} ${className}`.trim()} {...props} />
)

export const ButtonLink = ({
	href,
	variant,
	fullWidth,
	children,
}: {
	href: string
	variant?: ButtonVariant
	fullWidth?: boolean
	children: ReactNode
}) => (
	<Link href={href} className={buttonClasses(variant, fullWidth)}>
		{children}
	</Link>
)
